import { render, staticRenderFns } from "./StorageComponent.vue?vue&type=template&id=b5fa235e&scoped=true&"
import script from "./StorageComponent.vue?vue&type=script&lang=js&"
export * from "./StorageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fa235e",
  null
  
)

export default component.exports